import { render, staticRenderFns } from "./RegistroActividadFilters.vue?vue&type=template&id=007faac2&"
import script from "./RegistroActividadFilters.vue?vue&type=script&lang=js&"
export * from "./RegistroActividadFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports